import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPencil,  faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

const CropCategory = () => {
    const [value, setvalue] = useState("");
    const [cropCategoryData, setCropCategoryData] = useState([]);
    const [flag, setFlag] = useState(false);


  const [cropcategoryData, setcropcategoryData] = useState([]);
  const [cropCategoryValue, setCropCategoryValue] = useState("");
  const [deleteCode, setDeleteCode] = useState({});
  const [editCode, setEditCode] = useState("");

    useEffect(() => {
       
        fetchData();
    }, []);

    const fetchData = async () => {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropcategory`);
        setCropCategoryData(result.data.dataContent);
    };

    useEffect(() => {
        if (flag === true) {
          fetchData();
        }
      }, [flag]);

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'cropCategoryName',
                header: 'Crop Category Name',
            },
            {
                accessorKey: 'visibility',
                header: 'Visibility',
            },
            {
                accessor: "",
                header: "Actions",
                Cell: (cell) => (
                  <>
                    <i
                      className="btn text-primary"
                      type="button"
                      onClick={() => handleEditCropCategory(cell.row.original)}
                    >
                      <FontAwesomeIcon icon={faPencil} />
                    </i>
                    <i
                      className="btn text-danger"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#myDelete"
                      onClick={() =>
                        setDeleteCode({
                          cropcategoryCode: cell.row.original.cropCategoryCode,
                        })
                      }
                    >
                      {" "}
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </i>
                  </>
                ),
              }
        ],
        [],
    );

    function removed() {
        var mpopup = document.getElementById("mpopupBox");
        mpopup.style.display = "none";
        setCropCategoryValue("");
      }

    function removedAdd() {
        var mpopup = document.getElementById("addNewcropcategory");
        mpopup.style.display = "none";
        setCropCategoryValue("");
      }
    
      function handleEditCropCategory(value) {
        document.getElementById("cropcategoryEdit").value = value.cropCategoryName;
    
        // localUserTypeName = value.userTypeName
        // document.getElementById("userTypeEdit").defaultValue= ""
        // document.getElementById("userTypeEdit").defaultValue = value.userTypeName;
        setEditCode({
          cropCategoryCode: value.cropCategoryCode,
          cropCategoryName: value.cropCategoryName,
        });
        //   setUserTypeValue(value.seasonName)
        var x = document.createElement("a");
        x.id = "mpopupLink";
        var mpopup = document.getElementById("mpopupBox");
        mpopup.style.display = "block";
      }
    
      function AddNewcropcategory() {
        if (cropCategoryValue) {
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
    
          var raw = JSON.stringify({
            createdByUC: localStorage.getItem("userCodeGlobal"),
            cropcategoryName: cropCategoryValue,
          });
    
          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };
    
          fetch(
            `${
              process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/cropcategory`,
            requestOptions
          )
            .then((response) => response.text())
            .then((result) => {
              alert(JSON.parse(result).message);
              //   $('#addNewBtn').on('click', function () {
              // $('#addNewUserType').modal('hide');
              //  })
              if (JSON.parse(result).success === true) {
                // $('#addNewBtn').on('click', function () {
                // $('#addNewUserType').modal('hide');
                // })
    
                setFlag(true);
                setCropCategoryValue("");
                removedAdd()
              }
            })
            .catch((error) => console.log("error", error));
        } else {
          alert("Enter Category Name");
        }
      }
    
      function deleteData(value) {
    
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var raw = JSON.stringify(deleteCode);
    
        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    
        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropcategory`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success === true) {
                    fetchData()
    
                }
            })
            .catch(error => console.log('error', error));
    }
    
    function Editcropcategory() {
           
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        var raw = JSON.stringify({
            "modifiedByUC": localStorage.getItem("userCodeGlobal"),
            "cropCategoryCode": editCode.cropCategoryCode,
            "cropCategoryName": cropCategoryValue,
            "visibility": "Y"
          
        });
    
        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    
        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropcategory`, requestOptions)
            .then(response => response.text())
            .then(result => {
                alert(JSON.parse(result).message)
                if (JSON.parse(result).success === true) {
                    setCropCategoryValue("")
                    fetchData()
                    removed()
    
    
                }
            }
            )
            .catch(error => console.log('error', error));
           
    }
    
    function handleCropCategoryValue(value) {
        console.log("value@@", value)
        const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
        document.getElementById("cropcategoryEdit").value = valueFinal;
        setCropCategoryValue(valueFinal)
    }

    function handleAddNewData() {
      setCropCategoryValue("");
      setFlag(false)
    }

    return (
        <>
            
            <main id="main" className="main"> 
            <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                  
                    <nav>  <h1>Crop Category</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Master</li>
                            <li className="breadcrumb-item active">Crop Category</li>
                        </ol>
                    </nav>
                    <button
            type="button"
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#addNewcropcategory"
            onClick={() => handleAddNewData()}
          >
            Add New
          </button>
                </div>
                <section className="section">
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={cropCategoryData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                />
                            </div>

                        </div>

                        <div className="col-lg-6">

                        </div>
                    </div>
                    <div className="modal" id="addNewcropcategory">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                <label for="add_season" className="form-label">
                    Add New Crop Category
                  </label>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                 
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Add New "
                    onChange={(e) => handleCropCategoryValue(e.target.value)}
                    value={cropCategoryValue}
                    maxLength={50}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    id="addNewBtn"
                    // data-bs-dismiss="modal"
                    onClick={AddNewcropcategory}
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="mpopupBox" className="modal">
            <div className="modal-content">
              <div className="modal-header">
                <h2>View Details</h2>
              </div>
              <div className="madal-body" id="modal-content">
                <label for="edit_season" className="form-label">
                  Edit Crop Category
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="cropcategoryEdit"
                  placeholder=""
                  onChange={(e) => handleCropCategoryValue(e.target.value)}
                  maxLength={50}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={Editcropcategory}
                >
                  Add
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={removed}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <div className="modal" id="myDelete">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                  <p>Are you sure you want to delete this item?</p>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-dismiss="modal"
                    onClick={deleteData}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
                </section>

            </main>
           
        </>
    )
}

export default CropCategory;

